export class UserAffiliate {
  constructor(
    public isAffiliate: boolean = false,
    public status: string = null,
    public isActive: boolean = false
  ){}
}
